export const AUTH0_DOMAIN = 'luxsol-au.au.auth0.com';
export const AUTH0_CLIENT_ID = 'XY91NkJxIu3UplKcINMiXnjhmjkKsKfH';
export const AUTH0_CALLBACK_PATH = '/auth/callback';
